export const root = '/';
export const authorizationURL = '/oauth/discord';
export const socialURL = '/social';

export const hermesOAuthHelpURL = '';
export const hermesOAuthPrivacyURL = 'https://hermesprotocol.io/privacy_policy';
export const hermesOAuthTermsURL = 'https://hermesprotocol.io/terms';
